import z from "zod";
import { deviceIdSchema } from "../devices";
import { timestampsSchema } from "../helpers";
export const projectDeviceSchema = z.object({
    id: z.number(),
    deviceId: deviceIdSchema,
    online: z.boolean(),
});
export const projectSchema = z.object({
    id: z.number(),
    name: z.string(),
    description: z.string(),
    deviceId: z.number().nullable(),
    device: projectDeviceSchema.nullable(),
    cameraApiUrl: z.url().nullable(),
    cameraMxid: z.string().nullable(),
    multipleDashboardConfigs: z.boolean(),
    hasLicense: z.boolean(),
    organizationId: z.number(),
    taskCount: z.number(),
    annotatedTaskCount: z.number(),
    ...timestampsSchema,
});
export const createProjectRequestSchema = z.object({
    name: z.string().min(1).max(256),
    description: z.string(),
    deviceId: z.number().nullish(),
    cameraApiUrl: z.url().nullable(),
    cameraMxid: z.string().max(256).nullish(),
});
export const updateProjectRequestSchema = z.object({
    name: z.string().min(1).max(256),
    description: z.string(),
    deviceId: z.number().nullish(),
    cameraApiUrl: z.url().nullable(),
    cameraMxid: z.string().max(256).nullish(),
    multipleDashboardConfigs: z.boolean().optional(),
});
export var ProjectTypeEnum;
(function (ProjectTypeEnum) {
    ProjectTypeEnum["CLASSIFICATION"] = "CLASSIFICATION";
    ProjectTypeEnum["DETECTION"] = "DETECTION";
    ProjectTypeEnum["SEGMENTATION"] = "SEGMENTATION";
})(ProjectTypeEnum || (ProjectTypeEnum = {}));
export const projectListResponseSchema = z.object({
    projects: z.array(projectSchema),
});
//# sourceMappingURL=projects.schema.js.map